// src/utils/authChannel.js
export const authChannel = new BroadcastChannel("auth-channel");
